import { IPointProperties, IStacked } from '../../../../../types-library/src'
import { useEffect, useMemo, useRef } from 'react'

// import {
//   ListingPointProperties,
//   ListingStacked
// } from '@/src/interfaces/listingInsterface'
// import ListingItem from './ListingItem'
// import { useBoundStore } from '@/src/store'
// import { ITrackEventParams } from '@mo/web-components/providers/amplitud-provider/AmplitudeProvider'
// import { EAmplitudeEvent } from '@/src/interfaces'
// import {
//   getProviderName,
//   prepareStringForUrlAsPropertyId
// } from '@/src/utils/propertyUtils'
import { MdOutlineClose, MdOutlineInfo } from 'react-icons/md'
import PropertyItem from './PropertyItem'

interface Props {
  stacked: IStacked
  getRef: (ref: any) => void
  onClose: () => void
  // trackEvent: (params: ITrackEventParams) => void
  onSelect?: (listing: IPointProperties) => void
}

let lastHovered:
  | {
      id: string
      latitude: number
      longitude: number
    }
  | undefined

/**
 * This component is used to render the popup of the listing
 * @param listing The listing data
 * @param getRef The ref of the component
 * @returns {JSX.Element}
 */
const StackedList = ({
  stacked,
  getRef,
  onClose,
  // trackEvent,
  onSelect
}: Props): JSX.Element => {
  const ref = useRef<any>(null)

  // const { listingCardHovered, setListingId } = useBoundStore((state) => state)

  const stackedCount = useMemo(() => {
    return stacked?.properties?.stackedCount
  }, [stacked])

  const listings = useMemo(() => {
    const allListings = stacked?.properties?.stacked

    if (!lastHovered) {
      return allListings
    }

    const find = allListings?.find((item) => item.id === lastHovered?.id)

    if (find) {
      const otherListings = allListings.filter(
        (item) => item.id !== lastHovered?.id
      )
      return [find, ...otherListings]
    }

    return allListings
  }, [stacked, lastHovered])

  const uncertainLocation = useMemo(() => {
    return stacked?.properties?.uncertainLocation
  }, [stacked])

  const toSelect = (listing: IPointProperties): void => {
    onSelect?.(listing)
    // trackEvent({
    //   name: EAmplitudeEvent.LISTING_SELECTED,
    //   eventProperties: {
    //     operationType: listing?.listingType === 'for-sale' ? 'buy' : 'rent',
    //     where: 'map',
    //     provider: getProviderName(listing?.providerId),
    //     propertyId: listing?.id
    //   },
    //   configs: { login: true }
    // })

    // setListingId(
    //   listing?.itemId ? prepareStringForUrlAsPropertyId(listing) : listing?.id,
    //   'map',
    //   listing?.scraper,
    //   listing?.providerId?.toString()
    // )
  }
  useEffect(() => {
    if (!ref.current) {
      return
    }
    getRef(ref.current)
  }, [ref.current])

  // useEffect(() => {
  //   if (listingCardHovered) {
  //     lastHovered = listingCardHovered
  //   }
  // }, [listingCardHovered])

  return (
    <div
      ref={ref}
      className="relative w-full md:pb-3 h-full md:w-[440px] bg-white border border-[#ECECEC] rounded-t-2xl md:rounded-2xl overflow-hidden [box-shadow:0px_4px_20px_-4px_rgba(24,26,61,0.16)]"
    >
      <div className="h-[74px] flex items-center justify-between px-6 border-b border-surface-gray-20">
        <p className="text-headline-xxs text-black">
          Hay {stackedCount} anuncios disponibles
        </p>

        <button
          className="bg-surface-gray-10 flex justify-center items-center p-[9px] rounded-lg active:scale-90 duration-100"
          type="button"
          onClick={onClose}
        >
          <MdOutlineClose className="w-6 h-6 fill-tertiary-input" />
        </button>
      </div>

      <div className="h-[calc(100%-74px)] md:max-h-[265px] 2xl:max-h-[265px] overflow-y-auto ui-kit-scrollbar pb-3">
        <div className="px-3 pt-2 flex flex-col gap-3">
          {uncertainLocation ? (
            <div className="p-2 bg-surface-gray-10 rounded-lg flex items-center gap-2">
              <MdOutlineInfo className="w-6 h-6 fill-tertiary-input" />

              <p className="text-body-s text-tertiary-input">
                El asesor no dio una ubicación exacta para estos anuncios, es
                por eso que los mostramos en esta ubicación
              </p>
            </div>
          ) : null}

          {listings.map((listing) => {
            return (
              <PropertyItem
                key={listing.id}
                property={listing}
                onSelect={toSelect}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default StackedList
